import Component from '../classes/Component';
import lgVideo from 'lightgallery/plugins/video';

export const rootClassName = 'js-gallery';
export const itemClassName = 'js-gallery-item';

const rootSelector = `.${rootClassName}`;
const itemSelector = `.${itemClassName}`;

export default function () {

	return new Component({
		name: 'lightGallery',
		requiredTargets: [rootSelector],
        onCreate() {
		    this.galleries = [];
        },
		onInit() {
            import(/* webpackChunkName: "lightgallery" */ 'lightgallery')
                .then(({default: lightGallery}) => {
                    this.galleries = this.targets.map(target => lightGallery(target, {
                        plugins: [lgVideo],
                        selector: itemSelector,
                        autoplayVideoOnSlide: true,
                        download: false,
                        zoomFromOrigin: false,
                        //getCaptionFromTitleOrAlt: false,
                        mobileSettings: {
                            showCloseIcon: true
                        }
                    }));
                })
        },
		onDestroy() {
            this.galleries = this.galleries.filter(gallery => {
                gallery?.destroy && gallery.destroy();
                return false;
            })
        }
	})
}
